import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { getEffectiveFieldMode, useFieldMode } from './FieldModeContext';

/** Admins in field mode use admin settings, not the technician settings page. */
export default function FieldModeTechSettingsRedirect({
  children
}: {
  children: React.ReactNode;
}): React.JSX.Element {
  const { user } = useAuth();
  const { fieldMode } = useFieldMode();
  const { pathname } = useLocation();

  const onTechnicianSettings =
    pathname === '/technician/settings' || pathname.startsWith('/technician/settings/');

  if (user?.role === 'admin' && getEffectiveFieldMode(fieldMode) && onTechnicianSettings) {
    return <Navigate to="/admin/settings" replace />;
  }

  return <>{children}</>;
}
